import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Input, InputNumber, Row, Radio, Select, notification, Checkbox } from 'antd';
import { PlusSquareOutlined } from '@ant-design/icons';
import CommonCard from '../commonComponents/Card/Card';
import { useCheckUniqueCompanyCode, checkUniqueCompanyCode } from '../hooks/useCompanies';
import FMSConfigOptions from './FMSConfigOptions';

const { Option } = Select;
const OnboardNewClient = props => {
    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();
    const [isCompanyCodeUnique, setCompanyCodeUnique] = useState(false);

    const onSuccess = resp => {
        if (!resp.data.exists) return setCompanyCodeUnique(!resp.data.exists);
        else {
            setCompanyCodeUnique(false);
            return api['warning']({
                message: `Entered Company Code already exists under ${resp?.data?.companyName}`,
            });
        }
    };

    const { mutate: checkCompanyCodeExists } = useCheckUniqueCompanyCode(onSuccess);

    const onFinish = async values => {
        if (props.addresses.length === 0 || props.contacts.length === 0) {
            return api['warning']({
                message: 'please enter atleast one address and contact',
            });
        } else {
            if (!props?.companyId) {
                await checkUniqueCompanyCode(values.code).then(resp => {
                    if (!resp.data?.exists) {
                        props.onFinish(values);
                    }
                });
            } else {
                props?.onFinish(values);
                props?.setEditFormFlag(false);
            }
        }
    };

    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    return (
        <div className="newClient-main">
            {contextHolder}
            <Form
                key={props.name}
                name="basic"
                labelCol={{
                    xs: {
                        span: 24,
                    },
                    sm: {
                        span: 8,
                    },
                }}
                wrapperCol={{
                    xs: {
                        span: 24,
                    },
                    sm: {
                        span: 22,
                    },
                }}
                initialValues={{
                    remember: true,
                    name: props.name,
                    studio: props.preferName,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                className="newClient_form"
                form={form}
            >
                <Form.Item
                    label="Company Name"
                    name="name"
                    initialValue={props.name}
                    rules={[
                        {
                            required: true,
                            message: 'Please enter company name!',
                        },
                        {
                            validator: (_, value) => (value && !value.trim() ? Promise.reject(new Error('No spaces allowed')) : Promise.resolve()),
                        },
                    ]}
                >
                    <Input defaultValue={props.name} disabled={props?.companyId ? true : false} required />
                </Form.Item>
                <Form.Item
                    label="Company Code"
                    name="code"
                    initialValue={props.companyId ? props?.code : ''}
                    rules={[
                        {
                            required: true,
                            message: 'Please enter company code !',
                        },
                        {
                            min: 3,
                            message: 'Company code must be at least 3 characters!',
                        },
                        {
                            validator: (_, value) => (value && !value.trim() ? Promise.reject(new Error('No spaces allowed')) : Promise.resolve()),
                        },
                    ]}
                >
                    <Input
                        disabled={props?.companyId ? true : false}
                        required
                        onBlur={e => {
                            if (e.target.value && !props?.companyId) checkCompanyCodeExists(e.target.value);
                        }}
                    />
                </Form.Item>
                <Form.Item
                    label="Address"
                    name="address"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: 'Please enter your address!',
                    //   },
                    // ]}
                >
                    <div className="form_address">
                        <PlusSquareOutlined style={{ fontSize: '150%' }} onClick={e => props.ModalHandler('address')} />
                        <Row gutter={[16, 16]} className="address_row">
                            {props.addresses?.map(el => {
                                return (
                                    <Col span={8}>
                                        <CommonCard
                                            name={el?.contactPerson?.name}
                                            addressLine1={el?.addressLine1}
                                            addressLine2={el?.addressLine2}
                                            countryCode={el.zipCode}
                                            stateOrProvince={el.stateOrProvince}
                                            city={el.city}
                                            contactPerson={el.alias}
                                            country={el.country}
                                            hoverable
                                            type="address"
                                            id={el.id}
                                            deleteHandler={props.removeData}
                                        />
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                </Form.Item>
                <Form.Item
                    label="Contact Details"
                    name="contact"
                    rules={[
                        {
                            validator: (_, value) => (value && !value.trim() ? Promise.reject(new Error('No spaces allowed')) : Promise.resolve()),
                        },
                    ]}
                >
                    <div className="form_contact">
                        <PlusSquareOutlined style={{ fontSize: '150%' }} onClick={e => props.ModalHandler('contact')} />
                        <Row gutter={[16, 16]} className="address_row">
                            {props.contacts?.map(el => {
                                return (
                                    <Col span={8}>
                                        <CommonCard
                                            phoneNumber={el.phoneNumber.phoneNumber}
                                            countryCode={el.phoneNumber.countryCode}
                                            name={el?.name}
                                            email={el.email}
                                            designation={el.designation}
                                            hoverable
                                            type="contact"
                                            id={el.id}
                                            deleteHandler={props.removeData}
                                        />
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                </Form.Item>
                <Form.Item
                    label="Brand Information*"
                    name="contact"
                    rules={[
                        {
                            validator: (_, value) => (value && !value.trim() ? Promise.reject(new Error('No spaces allowed')) : Promise.resolve()),
                        },
                    ]}
                >
                    <div className="form_brand">
                        <PlusSquareOutlined style={{ fontSize: '150%' }} onClick={e => props.ModalHandler('brand')} />
                        <Row gutter={[16, 16]} className="address_row">
                            {props.brands?.map(el => {
                                return (
                                    <Col span={8}>
                                        <CommonCard
                                            hoverable
                                            brandCode={el.code}
                                            brandName={el.name}
                                            type="brand"
                                            id={el.id}
                                            deleteHandler={props.removeData}
                                        />
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                </Form.Item>
                <Form.Item
                    name="studio"
                    label="Preffered Studio"
                    rules={[
                        {
                            required: true,
                            message: 'Please select your studio !',
                        },
                    ]}
                >
                    <Select
                        placeholder="Select a Studio"
                        //onChange={props.onStudioChange}
                        allowClear
                    >
                        {props.studios?.map(el => {
                            return (
                                <Option key={el.id} value={el.id}>
                                    {el.name}
                                </Option>
                            );
                        })}
                    </Select>
                </Form.Item>
                <Form.Item label="Last Batch No" name="lastBatchNo" initialValue={props.lastBatchNo ? props?.lastBatchNo : ''}>
                    <InputNumber disabled={props?.companyId ? true : false} defaultValue={0} />
                </Form.Item>

                <Form.Item label="Preferred Post Production Configuration" name="fmsConfigOptions">
                    <FMSConfigOptions
                        onChange={config => {
                            form.setFieldValue('fmsConfigOptions', config);
                        }}
                    />
                </Form.Item>
                <Row>
                    <Col
                        span={23}
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        {props?.companyId && (
                            <Button
                                onClick={() => props.setEditFormFlag(false)}
                                style={{
                                    margin: '0 8px',
                                }}
                                size="large"
                            >
                                Cancel
                            </Button>
                        )}
                        <Button type="primary" htmlType="submit" size="large" disabled={!isCompanyCodeUnique && !props?.companyId}>
                            Ok
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};
export default OnboardNewClient;
